import { render, staticRenderFns } from "./buttonAddNebenbewerbung.vue?vue&type=template&id=35d6a68a"
import script from "./buttonAddNebenbewerbung.vue?vue&type=script&lang=js"
export * from "./buttonAddNebenbewerbung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports